<template>
  <section class="flex flex-col items-center px-4 py-2.5 bg-gradient-to-b" style="background: linear-gradient(180deg, #105857 0%, #5AA2A1 100%);">
    <p
      class="text-xs text-center text-white uppercase font-ww-regular sm:text-sm"
      v-html="bannerText"
    />
  </section>
</template>

<script setup>
defineProps({
  bannerText: {
    type: String,
    default: 'Lifeboost Coffee — Over 60 Million Clean Cups Enjoyed — 3rd Party Tested & Low-Acid'
  }
})

defineBuilderComponent({
  friendlyName: 'Banner - Trust Banner',
  inputs: [
    {
      name: 'bannerText',
      type: 'richText',
      defaultValue: 'Lifeboost Coffee — Over 60 Million Clean Cups Enjoyed — 3rd Party Tested & Low-Acid'
    }
  ]
})
</script>
